import { render, staticRenderFns } from "./DeliveryReceiptsFilters.vue?vue&type=template&id=0008b334&"
import script from "./DeliveryReceiptsFilters.vue?vue&type=script&lang=js&"
export * from "./DeliveryReceiptsFilters.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryReceiptsFilters.vue?vue&type=style&index=0&id=0008b334&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports